const configs = {
  localhost: {
    env: 'test',
    wechatAppId: 'wx3a08b7674f00beeb',
    appId: {
      1: '23102',
      2: '86925', // 学生进出无测试环境
      5: '114801',
      7: '122729',
      8: '130920',
      9: '133316',
      12: '139715'
    },
    ablumAppId: '5000000006435603', // 电子相册appId
    backStageTowerHost: 'http://tbs.test.moredian.com:8002', // 后台服务
    facedoorH5Url: 'http://tding.test.moredian.com:8002/facedoor/',
    visitorH5Url: 'http://tding.test.moredian.com:8002/visitor/',
    healthH5Url: 'http://tding.test.moredian.com:8002/campushealth/',
    // apiHost: 'http://localhost:3300',
    apiHost: 'http://tcampus.test.moredian.com:8002',
    h5Host: 'http://tding.test.moredian.com:8002/campusleave',
    castUrl: 'http://tding.test.moredian.com:8002/maxdata/',
    backStageHost: 'http://bs.test.moredian.com:8002', // 后台服务
    redirectUrl: 'https://market.moredian.com/h5/index.html', // 微信免登
    aiScreenHost: 'http://tding.test.moredian.com:8002/campusscreen/#/', // 校园监控
    disciplinaryUrl: 'http://tding.test.moredian.com:8002/disciplinary/#/', // 违纪行为上墙
    securityCenterHost: 'http://tding.test.moredian.com:8002/antibully', // 安保中心
    imagicubeUrl: 'https://imagicube3.test.moredian.com:1094/tpark/', // 行业储物柜
    lockDoorUrl: 'https://imagicube3.test.moredian.com:1094/tfacedoor/', // 智能门锁
    gsUrl: 'https://facemagic.test.moredian.com:1102/campusleave' // 拱墅人脸库
  },
  'tding.dev.moredian.com': {
    env: 'development',
    wechatAppId: 'wx3a08b7674f00beeb',
    appId: {
      1: '3025',
      2: '86925',
      5: '112438',
      7: '122714',
      8: '130837',
      9: '133316',
      12: '139715'
    },
    ablumAppId: '5000000006435603', // 电子相册appId
    backStageTowerHost: 'http://tbs.dev.moredian.com:8000', // 后台服务
    // apiHost: 'http://localhost:3300',
    facedoorH5Url: 'http://tding.dev.moredian.com:8000/facedoor/',
    visitorH5Url: 'http://tding.dev.moredian.com:8000/visitor/',
    apiHost: 'http://tcampus.dev.moredian.com:8000',
    // apiHost: 'https://tcampus.dev.moredian.com:9000',
    h5Host: 'http://tding.dev.moredian.com:8000/campusleave',
    castUrl: 'http://tding.dev.moredian.com:8000/maxdata/',
    healthH5Url: 'http://tding.dev.moredian.com:8000/campushealth/',
    backStageHost: 'http://bs.dev.moredian.com:8000', // 后台服务
    redirectUrl: 'https://market.moredian.com/h5/index.html', // 微信免登
    aiScreenHost: 'http://tding.dev.moredian.com:8000/campusscreen/#/', // 校园监控
    disciplinaryUrl: 'http://tding.dev.moredian.com:8000/disciplinary', // 违纪行为上墙
    securityCenterHost: 'http://tding.dev.moredian.com:8000/antibully', // 安保中心
    imagicubeUrl: 'https://imagicube2.dev.moredian.com:1090/tpark/', // 行业储物柜
    lockDoorUrl: 'https://imagicube2.dev.moredian.com:1090/tfacedoor/', // 智能门锁
    gsUrl: 'https://facemagic.test.moredian.com:1102/campusleave' // 拱墅人脸库
  },
  'https://tding.dev.moredian.com': {
    env: 'development',
    wechatAppId: 'wx3a08b7674f00beeb',
    appId: {
      1: '3025',
      2: '86925',
      5: '112438',
      7: '122714',
      8: '130837',
      9: '133316',
      12: '139715'
    },
    backStageTowerHost: 'http://tbs.dev.moredian.com:8000', // 后台服务
    // apiHost: 'http://localhost:3000',
    facedoorH5Url: 'http://tding.dev.moredian.com:8000/facedoor/',
    visitorH5Url: 'http://tding.dev.moredian.com:8000/visitor/',
    apiHost: 'https://tcampus.dev.moredian.com:9000',
    // apiHost: 'https://tcampus.dev.moredian.com:9000',
    h5Host: 'http://tding.dev.moredian.com:8000/campusleave',
    castUrl: 'http://tding.dev.moredian.com:8000/maxdata/',
    healthH5Url: 'http://tding.dev.moredian.com:8000/campushealth/',
    backStageHost: 'http://bs.dev.moredian.com:8000', // 后台服务
    redirectUrl: 'https://market.moredian.com/h5/index.html', // 微信免登
    aiScreenHost: 'http://tding.dev.moredian.com:8000/campusscreen/#/', // 校园监控
    disciplinaryUrl: 'http://tding.dev.moredian.com:8000/disciplinary', // 违纪行为上墙
    securityCenterHost: 'http://tding.dev.moredian.com:8000/antibully', // 安保中心
    imagicubeUrl: 'https://imagicube2.dev.moredian.com:1090/tpark/', // 行业储物柜
    lockDoorUrl: 'https://imagicube2.dev.moredian.com:1090/tfacedoor/', // 智能门锁
    gsUrl: 'https://facemagic.test.moredian.com:1102/campusleave' // 拱墅人脸库
  },
  'tding.test.moredian.com': {
    env: 'test',
    wechatAppId: 'wx3a08b7674f00beeb',
    appId: {
      1: '23102',
      2: '86925', // 学生进出无测试环境
      5: '114801',
      7: '122729',
      8: '130920',
      9: '133316',
      12: '139715'
    },
    ablumAppId: '5000000006435603', // 电子相册appId
    backStageTowerHost: 'http://tbs.test.moredian.com:8002', // 后台服务
    facedoorH5Url: 'http://tding.test.moredian.com:8002/facedoor/',
    visitorH5Url: 'http://tding.test.moredian.com:8002/visitor/',
    healthH5Url: 'http://tding.test.moredian.com:8002/campushealth/',
    // apiHost: 'http://localhost:3300',
    apiHost: 'http://tcampus.test.moredian.com:8002',
    h5Host: 'http://tding.test.moredian.com:8002/campusleave',
    castUrl: 'http://tding.test.moredian.com:8002/maxdata/',
    backStageHost: 'http://bs.test.moredian.com:8002', // 后台服务
    redirectUrl: 'https://market.moredian.com/h5/index.html', // 微信免登
    aiScreenHost: 'http://tding.test.moredian.com:8002/campusscreen/#/', // 校园监控
    disciplinaryUrl: 'http://tding.test.moredian.com:8002/disciplinary/#/', // 违纪行为上墙
    securityCenterHost: 'http://tding.test.moredian.com:8002/antibully', // 安保中心
    imagicubeUrl: 'https://imagicube3.test.moredian.com:1094/tpark/', // 行业储物柜
    lockDoorUrl: 'https://imagicube3.test.moredian.com:1094/tfacedoor/', // 智能门锁
    gsUrl: 'https://facemagic.test.moredian.com:1102/campusleave' // 拱墅人脸库
  },

  'tding.moredian.com': {
    env: 'production',
    wechatAppId: 'wx8912c9d31ecb1f08', // 'wx8912c9d31ecb1f08',
    appId: {
      1: '2906',
      2: '84372',
      5: '113503',
      7: '122730',
      8: '130838',
      9: '133322',
      12: '139716'
    },
    ablumAppId: '5000000006442472', // 电子相册appId
    backStageTowerHost: 'https://tbs.moredian.com', // 后台服务
    facedoorH5Url: 'https://tfront.moredian.com/facedoor/',
    visitorH5Url: 'https://tding.moredian.com/visitor/',
    healthH5Url: 'https://tding.moredian.com/campushealth/',
    apiHost: 'https://app2906.eapps.dingtalkcloud.com',
    h5Host: 'https://tding.moredian.com/campusleave',
    castUrl: 'https://r.modst.cn/1',
    backStageHost: 'https://bs.moredian.com', // 后台服务
    redirectUrl: 'https://market.moredian.com/h5/index.html', // 微信免登
    aiScreenHost: 'https://r.modst.cn/jk', // 监控大屏
    aiExeScreenHost: 'https://r.modst.cn/jk/#/nsis/Setup.exe', // 监控大屏-解码控件
    disciplinaryUrl: 'https://r.modst.cn/wj', // 违纪行为上墙
    securityCenterHost: 'https://r.modst.cn/af', // 安防中心
    imagicubeUrl: 'https://imagicube.moredian.com/tpark/', // 行业储物柜
    lockDoorUrl: 'https://imagicube.moredian.com/tfacedoor/', // 智能门锁
    gsUrl: 'https://gsrlk-imagicube.hzgsedu.cn/campusleave' // 拱墅人脸库
  },

  'app2906.eapps.dingtalkcloud.com': {
    env: 'production',
    wechatAppId: 'wx8912c9d31ecb1f08',
    appId: {
      1: '2906',
      2: '84372',
      5: '113503',
      7: '122730',
      8: '130838',
      9: '133322',
      12: '139716'
    },
    ablumAppId: '5000000006442472', // 电子相册appId
    backStageTowerHost: 'https://tbs.moredian.com', // 后台服务
    facedoorH5Url: 'https://tfront.moredian.com/facedoor/',
    visitorH5Url: 'https://tding.moredian.com/visitor/',
    healthH5Url: 'https://tding.moredian.com/campushealth/',
    apiHost: 'https://app2906.eapps.dingtalkcloud.com',
    h5Host: 'https://tding.moredian.com/campusleave',
    castUrl: 'https://r.modst.cn/1',
    backStageHost: 'https://bs.moredian.com', // 后台服务
    redirectUrl: 'https://market.moredian.com/h5/index.html', // 微信免登
    aiScreenHost: 'https://r.modst.cn/jk', // 监控大屏
    aiExeScreenHost: 'https://r.modst.cn/jk/#/nsis/Setup.exe', // 监控大屏-解码控件
    disciplinaryUrl: 'https://r.modst.cn/wj', // 违纪行为上墙
    securityCenterHost: 'https://r.modst.cn/af', // 安防中心
    imagicubeUrl: 'https://imagicube.moredian.com/tpark/', // 行业储物柜
    lockDoorUrl: 'https://imagicube.moredian.com/tfacedoor/', // 智能门锁
    gsUrl: 'https://gsrlk-imagicube.hzgsedu.cn/campusleave' // 拱墅人脸库
  }
}
let configKey = window.location.hostname
if (window.location.origin === 'https://tding.dev.moredian.com:9000') {
  configKey = 'https://tding.dev.moredian.com'
}
module.exports = configs[configKey]
